module.exports = __webpack_public_path__ + "media/images/shared/member-icon-orange-2daf7980c1997cffc37fd9b123ea0f2f.png";